function GoodStatus() {
  return (
    <button disabled class="outline outline-green-700 bg-green-100 text-green-700 font-bold py-1 px-4 rounded-full">
      Good
    </button>
  );
}

export default GoodStatus;
